import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImgClipComponent } from './img-clip.component';

@NgModule({
    declarations: [
        ImgClipComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        ImgClipComponent
    ]
})
export class NcImgClipModule { }